import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  Input,
} from "@chakra-ui/react";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import imageIcon from "../../../assets/images/booking/image.svg";
import {
  InputControl,
  InputDatePicker,
  SelectControl,
} from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { useCategories } from "../../../categorys/bookingManagement/detail";
import { bookingImageCall } from "../../../api/bookingImage";
import { formatPriceUS } from "../../../utils/utils";
import { useApartment } from "../../../hooks/useApartments";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { bookingCall } from "../../../api/booking";
import { bookingEventCall } from "../../../api/bookingEvent";
import { useRef } from "react";
import { commonCall } from "../../../api/common";
import toast from "react-hot-toast";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const schema = Yup.object().shape({
  // price: Yup.number()
  //   .nullable()
  //   .transform((value, originalValue) => {
  //     if (typeof originalValue === "string") {
  //       return originalValue.trim() === "" ? null : Number(originalValue);
  //     }
  //     return originalValue === null ? null : Number(originalValue);
  //   })
  //   .moreThan(0, "Số tiền booking phải lớn hơn 0"),
  // .required("Số tiền booking là bắt buộc"),
  // bookerId: Yup.string().required("Vui lòng chọn nhân viên tạo"),
  // customerId: Yup.string().required("Vui lòng chọn khách hàng"),
  // bookingEventId: Yup.string().required("Vui lòng chọn đợt nhận booking"),
  // projectId: Yup.string().required("Vui lòng chọn dự án"),
  // bookingTime: Yup.string().required("Vui lòng chọn ngày booking"),
  // // delegationImage: Yup.string().required("Vui lòng chọn ảnh ủy nhiệm chi"),
  // delegationImage: Yup.array()
  //   .of(
  //     Yup.object({
  //       id: Yup.mixed().required(),
  //       status: Yup.boolean().required(),
  //     })
  //   )
  //   .test("check-empty", "Vui lòng chọn ảnh ủy nhiệm chi", (value) => {
  //     return Array.isArray(value) && value.length > 0;
  //   })
  //   .test("check-status", "Vui lòng chọn ảnh và upload ảnh", (value) => {
  //     if (!Array.isArray(value) || value.length === 0) return true;
  //     return value.every((img) => img.status === true);
  //   }),
});

const FormDetail = memo(
  ({ isOpen, onClose, onSubmit, isEdit, defaultValues }) => {
    const {
      reset,
      register,
      handleSubmit,
      watch,
      setValue,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      defaultValues: defaultValues || {},
    });

    const [shouldFetch, setShouldFetch] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShouldFetch(true);
      }, 1200);

      return () => clearTimeout(timer);
    }, []);

    const { constantData } = useCategories(
      watch("bookerId") || defaultValues?.bookerId,
      shouldFetch
    );

    const { apartmentData } = useApartment(
      "",
      watch("projectId") || defaultValues?.projectId
    );

    const apartmentConstantData = apartmentData?.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    const formatEntries = (entries) =>
      Object.entries(entries || {}).map(([key, value]) => ({
        value: key,
        label: value,
      }));

    const formatEntrieAps = (entries) =>
      Object.entries(entries || {}).map(([key, value]) => ({
        value: key,
        label: value.name,
        code: value.code,
      }));

    const projects = useMemo(
      () => formatEntries(constantData?.project),
      [constantData?.project]
    );
    const apartments = useMemo(
      () => formatEntrieAps(apartmentConstantData),
      [apartmentData]
    );
    const customers = useMemo(
      () => formatEntries(constantData?.customer),
      [constantData?.customer]
    );
    const employeeDatas = useMemo(() => {
      if (!constantData?.employeeData) return [];

      return Object.entries(constantData.employeeData).map(
        ([id, { fullName, code }]) => ({
          value: id,
          label: `${fullName} (${code})`,
        })
      );
    }, [constantData?.employeeData]);
    const bookingEvents = useMemo(
      () => formatEntrieAps(constantData?.bookingEvent),
      [constantData?.bookingEvent]
    );

    const [focusStates, setFocusStates] = useState({});

    const [isLoadingUpload, setIsloadingUpload] = useState(false);
    const [delegationImage, setDelegationImage] = useState([]);
    const [delegationImageError, setDelegationImageError] = useState(false);
    const imageRefs = useRef([]);

    const [displayPrice, setDisplayPrice] = useState(0);
    const onChangePrice = useCallback(
      (event) => {
        const { value } = event.target;
        const numericValue = value.replace(/[^0-9]/g, "");
        setDisplayPrice(formatPriceUS(numericValue));
        setValue("price", Number(numericValue), {
          shouldValidate: true,
        });
      },
      [setValue, watch, formatPriceUS]
    );

    useEffect(() => {
      reset(defaultValues);
      if (defaultValues) {
        setDisplayPrice(formatPriceUS(defaultValues?.price || 0));
      } else {
        setDisplayPrice(formatPriceUS(0));
      }

      if (defaultValues?.id) {
        if (Array.isArray(defaultValues?.images)) {
          const initImages = defaultValues?.images?.map((image, idx) => ({
            id: image?._id || Date.now() + idx,
            path: image?.path || "",
            imageUrl: null,
            file: null,
            status: true, // ảnh đã upload
          }));
          setDelegationImage(initImages);
        }
      } else {
        setDelegationImage([]);
      }
    }, [isOpen]);

    useEffect(() => {
      setValue("delegationImage", delegationImage);
      if (
        delegationImage?.length > 0 &&
        delegationImage?.filter((img) => img.status === false)
      ) {
        setDelegationImageError(true);
      } else {
        setDelegationImageError(false);
      }
    }, [delegationImage, setValue]);

    const handleFocus = (field) => {
      setFocusStates((prev) => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field) => {
      setFocusStates((prev) => ({ ...prev, [field]: false }));
    };

    const handleDateChange = (selectedDate, inputName) => {
      setValue(inputName, selectedDate, { shouldValidate: true });

      // setInputColors((prevColors) => ({
      //   ...prevColors,
      //   [inputName]: selectedDate
      //     ? "var(--color-info-employee)"
      //     : "var(--color-text-unclick)",
      // }));
    };

    // xử lý chọn nhiều ảnh
    const handleAddDelegationImage = () => {
      setDelegationImage((prev) => {
        const newImage = {
          id: Date.now(),
          path: null,
          imageUrl: null,
          file: null,
          status: false,
        };

        setTimeout(() => {
          const index = prev.length; // index mới
          imageRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100); // để DOM cập nhật xong mới scroll

        return [...prev, newImage];
      });
    };

    // Chọn ảnh là tự upload (selectedFile), nút "Tải lại" chỉ dùng khi upload lỗi
    const handleUploadDelegationImage = async (index, selectedFile) => {
      const file = selectedFile || delegationImage[index]?.file;
      if (!file) return;

      // Tìm ảnh theo file vì trong lúc upload có thể đã xoá ô khác hoặc chọn ảnh khác
      const updateImage = (data) =>
        setDelegationImage((prev) => {
          const position = prev.findIndex((item) => item?.file === file);
          if (position < 0) return prev;
          const updated = [...prev];
          updated[position] = { ...updated[position], ...data };
          return updated;
        });

      updateImage({ uploading: true });

      try {
        const { filePath } = await commonCall.uploadFile(
          file,
          "salesContractImage"
        );

        if (filePath) {
          updateImage({ path: filePath, status: true, uploading: false });
          toast.success("Upload ảnh thành công");
          clearErrors("delegationImage");
        } else {
          updateImage({ uploading: false });
          toast.error("Upload thất bại");
        }
      } catch (error) {
        // commonCall.uploadFile đã báo lỗi bằng toast
        updateImage({ uploading: false });
      }
    };

    const handleChangeDelegationImage = (e, index) => {
      const file = e.target.files[0];
      if (!file) return;

      const imageUrl = URL.createObjectURL(file);
      const updated = [...delegationImage];
      updated[index] = {
        ...updated[index],
        file,
        imageUrl,
        status: false,
        path: null,
      };
      setDelegationImage(updated);
      handleUploadDelegationImage(index, file);
    };

    const handleRemoveDelegationImage = (index) => {
      const updated = [...delegationImage];
      updated.splice(index, 1);
      setDelegationImage(updated);
      if (delegationImage?.length === 0) {
        setDelegationImageError(false);
      }
    };
    // kết thúc xử lý

    const onchangeProject = (option) => {
      setValue("projectId", option);
    };

    const onchangeProduct = (option) => {
      setValue("apartmentId", option);
    };

    const onchangeCustomer = (option) => {
      setValue("customerId", option);
    };

    const onchangeEmpoyeeList = (option) => {
      setValue("bookerId", option);
    };

    const onchangeBookingEvents = async (option) => {
      setValue("bookingEventId", option);

      try {
        let data = await bookingEventCall.getId(option);

        if (data?.projectId) {
          setValue("projectId", data?.projectId);
        }

        if (data?.price) {
          setValue("price", data?.price);
          setDisplayPrice(Number(data?.price));
          clearErrors("price");
        }
      } catch (error) {
        console.log(error);
      }
    };

    // const changeImage = (event, type, id) => {
    //   const file = event.target.files[0];
    //   if (file) {
    //     const reader = new FileReader();
    //     const imageUrl = URL.createObjectURL(file);

    //     reader.onload = (e) => {
    //       if (type === 1) {
    //         setInfident1((prev) => ({
    //           ...prev,
    //           id: id || Date.now(),
    //           imageUrl: imageUrl,
    //           file: file,
    //           status: false,
    //         }));
    //       } else if (type === 2) {
    //         setInfident2((prev) => ({
    //           ...prev,
    //           id: id || Date.now(),
    //           imageUrl: imageUrl,
    //           file: file,
    //           status: false,
    //         }));
    //       } else {
    //         setImagePayment((prev) => ({
    //           ...prev,
    //           id: id || Date.now(),
    //           imageUrl: imageUrl,
    //           file: file,
    //           status: false,
    //         }));
    //       }
    //     };

    //     reader.readAsDataURL(file);
    //   }
    // };

    const submitHandler = (data) => {
      // if (!infident1?.status) {
      //   data.infident1 = infident1;
      // }
      // if (!infident2?.status) {
      //   data.infident2 = infident2;
      // }
      // if (!imagePayment?.status) {
      //   data.imagePayment = imagePayment;
      // }

      if (delegationImage?.length > 0) {
        data.delegationImage = delegationImage
          .filter((img) => img?.path)
          .map((img) => img.path);
      }

      // console.log(data)
      onSubmit(data);
    };

    return (
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          backgroundColor="var(--color-main)"
          borderRadius={"16px"}
          position={"relative"}
          w={"100%"}
          maxW={"625px"}
        >
          <form onSubmit={handleSubmit(submitHandler)}>
            <Box
              paddingBottom={"80px"}
              h={"86.5vh"}
              w={"100%"}
              overflowY={"scroll"}
              sx={{
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
                "&::-webkit-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
                "&::-moz-scrollbar": {
                  width: "4px",
                },
                "&::-moz-scrollbar-thumb": {
                  width: "4px",
                  borderRadius: "50px",
                  background: "var(--color-background)",
                },
              }}
            >
              <Flex
                alignItems={"center"}
                p={"25px 24px 24px 24px"}
                position={"relative"}
                borderBottom={"1px solid var(--border-input-employee)"}
              >
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  {isEdit ? "Chỉnh sửa Booking" : "Tạo Booking"}
                </Text>
                <Box
                  position={"absolute"}
                  top={"24px"}
                  right={"24px"}
                  cursor={"pointer"}
                  onClick={onClose}
                >
                  <Image src={IconX} />
                </Box>
              </Flex>
              <Box
                paddingTop={"24px"}
                paddingBottom={"41px"}
                maxW={"545px"}
                margin={"0 auto"}
              >
                <Box>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin chung
                  </Text>
                  <Box mt={"16px"} borderRadius={"8px"}>
                    <Box>
                      <InputControl
                        // label="Tên đợt booking"
                        // placeholder="Nhập tên đợt booking"
                        label="Ghi chú"
                        placeholder="Nhập ghi chú"
                        errors={errors.note}
                        register={register("note")}
                        onFocus={() => handleFocus("note")}
                        onBlur={() => handleBlur("note")}
                        state={focusStates["note"]}
                        mwidth="100%"
                      />
                      <Text
                        lineHeight={"15px"}
                        fontSize={{ base: "12px" }}
                        fontWeight={400}
                        mt={{ base: "4px" }}
                        color={"var(--color-option-employee-hover)"}
                      >
                        ( Nhập nhu cầu khách hàng * )
                      </Text>
                    </Box>
                    <Flex mt={"16px"} gap={"27px"}>
                      <SelectControl
                        label="Đợt nhận booking"
                        dataOption={bookingEvents}
                        placeholder="Chọn đợt nhận booking"
                        selectedMain={watch("bookingEventId")}
                        onChange={onchangeBookingEvents}
                        onFocus={() => handleFocus("bookingEventId")}
                        onBlur={() => handleBlur("bookingEventId")}
                        state={focusStates["bookingEventId"]}
                        registerProps={register("bookingEventId")}
                        errorMessage={errors.bookingEventId}
                        mwidth="100%"
                        isSearchable={true}
                        // getCode={true}
                        // isRequired={true}
                      />
                    </Flex>
                    {isEdit && (
                      <Flex mt={"12px"} gap={"27px"}>
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Người tạo booking
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {defaultValues?.nameBooker || ""}
                          </Text>
                        </Box>
                        <Box flex={"1"}>
                          <Text
                            color={"var(--color-label-employee)"}
                            fontSize={"12px"}
                          >
                            Ngày tạo booking
                          </Text>
                          <Text
                            color={"var(--color-option-employee)"}
                            fontSize={"14px"}
                            fontWeight={"500"}
                            mt={"8px"}
                          >
                            {defaultValues?.createdAt || ""}
                          </Text>
                        </Box>
                      </Flex>
                    )}
                    <Flex mt={"16px"} gap={"27px"}>
                      <SelectControl
                        label="Dự án"
                        dataOption={projects}
                        placeholder="Chọn dự án"
                        selectedMain={watch("projectId")}
                        onChange={onchangeProject}
                        onFocus={() => handleFocus("projectId")}
                        onBlur={() => handleBlur("projectId")}
                        state={focusStates["projectId"]}
                        registerProps={register("projectId")}
                        errorMessage={errors.projectId}
                        mwidth={"259px"}
                        isSearchable={true}
                        // isRequired={true}
                      />
                      <SelectControl
                        label="Sản phẩm"
                        dataOption={apartments}
                        placeholder="Chọn sản phẩm"
                        selectedMain={watch("apartmentId")}
                        onChange={onchangeProduct}
                        onFocus={() => handleFocus("apartmentId")}
                        onBlur={() => handleBlur("apartmentId")}
                        state={focusStates["apartmentId"]}
                        registerProps={register("apartmentId")}
                        errorMessage={errors.apartmentId}
                        mwidth={"259px"}
                        isSearchable={true}
                        getCode={true}
                      />
                    </Flex>
                    <Flex mt={"16px"} gap={"27px"}>
                      <InputControl
                        // type="number"
                        label="Số tiền booking"
                        placeholder="Ví dụ: 1 tỷ 950 triệu "
                        errors={errors.price}
                        register={register("price")}
                        onFocus={() => handleFocus("price")}
                        onBlur={() => handleBlur("price")}
                        onChange={onChangePrice}
                        value={displayPrice}
                        state={focusStates["price"]}
                        mwidth={"100%"}
                        // isRequired={true}
                      />
                      <InputDatePicker
                        label={"Ngày booking"}
                        focusStates={focusStates["bookingTime"]}
                        selected={watch("bookingTime")}
                        onFocus={() => handleFocus("bookingTime")}
                        onBlur={() => handleBlur("bookingTime")}
                        onChange={(date) =>
                          handleDateChange(date, "bookingTime")
                        }
                        dateFormat="dd/MM/yyyy"
                        locale="vi"
                        placeholderText="dd/mm/yy"
                        errors={errors?.bookingTime}
                        formControlStyle={{
                          maxW: "259px",
                        }}
                        formLabelStyle={{
                          fontWeight: 400,
                          lineHeight: "15px",
                          fontSize: "12px",
                          mb: "6px",
                        }}
                        zIndex={3}
                        // isRequired={true}
                      />
                    </Flex>
                    <Flex
                      justifyContent={"space-between"}
                      alignItems={"flex-start"}
                      gap={"27px"}
                      mt={"16px"}
                    >
                      <SelectControl
                        label={"Nhân viên tạo"}
                        dataOption={employeeDatas}
                        placeholder="Chọn nhân viên"
                        selectedMain={watch("bookerId")}
                        onChange={onchangeEmpoyeeList}
                        onFocus={() => handleFocus("bookerId")}
                        onBlur={() => handleBlur("bookerId")}
                        state={focusStates["bookerId"]}
                        registerProps={register("bookerId")}
                        errorMessage={errors.bookerId}
                        mwidth="100%"
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </Flex>
                  </Box>
                </Box>
                <Box mt={"24px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin khách hàng
                  </Text>
                  <Box mt={"16px"}>
                    <Flex maxW="259px">
                      <SelectControl
                        label="Tên khách hàng"
                        dataOption={customers}
                        placeholder="Chọn khách hàng"
                        selectedMain={watch("customerId")}
                        onChange={onchangeCustomer}
                        onFocus={() => handleFocus("customerId")}
                        onBlur={() => handleBlur("customerId")}
                        state={focusStates["customerId"]}
                        registerProps={register("customerId")}
                        errorMessage={errors.customerId}
                        mwidth="259px"
                        // isRequired={true}
                        isSearchable={true}
                      />
                    </Flex>
                  </Box>
                </Box>

                {/* Xử lý ảnh */}
                {/* <Box mt={"16px"}>
                  <Flex gap={"27px"}>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Ảnh CCCD mặt trước
                      </Text>
                      <Box mt={"8px"}>
                        <Box
                          position={"relative"}
                          overflow={"hidden"}
                          w={"259px"}
                          height={"146px"}
                          display={"block"}
                          border={"0.5px solid var(--bg-line-employee)"}
                          borderRadius={"8px"}
                        >
                          {(infident1?.path || infident1?.imageUrl) && (
                            <Image
                              src={
                                infident1?.imageUrl
                                  ? infident1?.imageUrl
                                  : `${baseURL}/${infident1?.path}`
                              }
                              position={"absolute"}
                              top={0}
                              left={0}
                              right={0}
                              bottom={0}
                              objectFit={"cover"}
                              w={"100%"}
                              h={"100%"}
                              borderRadius={"8px"}
                            />
                          )}

                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            bottom={"8px"}
                          >
                            <Box
                              padding={"8px"}
                              bg={"var(--color-main)"}
                              borderRadius={"50%"}
                              cursor={"pointer"}
                              mr={"8px"}
                              position={"relative"}
                            >
                              <Input
                                type="file"
                                accept="image/*"
                                multiple
                                opacity={0}
                                position="absolute"
                                top={0}
                                left={0}
                                width="100%"
                                height="100%"
                                cursor="pointer"
                                onChange={(e) =>
                                  changeImage(e, 1, infident1?.id)
                                }
                              />
                              <Image
                                src={imageIcon}
                                _hover={{
                                  filter: "var(--filter-red)",
                                }}
                              />
                            </Box>
                          </Flex>
                        </Box>
                      </Box>
                    </Box>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Ảnh CCCD mặt trước
                      </Text>
                      <Box mt={"8px"}>
                        <Box
                          position={"relative"}
                          overflow={"hidden"}
                          w={"259px"}
                          height={"146px"}
                          display={"block"}
                          border={"0.5px solid var(--bg-line-employee)"}
                          borderRadius={"8px"}
                        >
                          {(infident2?.path || infident2?.imageUrl) && (
                            <Image
                              src={
                                infident2?.imageUrl
                                  ? infident2?.imageUrl
                                  : `${baseURL}/${infident2?.path}`
                              }
                              position={"absolute"}
                              top={0}
                              left={0}
                              right={0}
                              bottom={0}
                              objectFit={"cover"}
                              w={"100%"}
                              h={"100%"}
                              borderRadius={"8px"}
                            />
                          )}
                          <Flex
                            position={"absolute"}
                            right={"8px"}
                            bottom={"8px"}
                            cursor={"pointer"}
                          >
                            <Box
                              padding={"8px"}
                              bg={"var(--color-main)"}
                              borderRadius={"50%"}
                              mr={"8px"}
                              position={"relative"}
                            >
                              <Input
                                type="file"
                                accept="image/*"
                                multiple
                                opacity={0}
                                position="absolute"
                                top={0}
                                left={0}
                                width="100%"
                                height="100%"
                                cursor="pointer"
                                onChange={(e) =>
                                  changeImage(e, 2, infident2?.id)
                                }
                              />
                              <Image
                                src={imageIcon}
                                _hover={{
                                  filter: "var(--filter-red)",
                                }}
                              />
                            </Box>
                          </Flex>
                        </Box>
                      </Box>
                    </Box>
                  </Flex>
                </Box> */}
                {/* <Box mt={"16px"}>
                  <Flex>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Ảnh ủy nhiệm chi
                      </Text>
                      <Flex
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                        position={"relative"}
                      >
                        <Box
                          overflow={"hidden"}
                          w={"202px"}
                          h={"300px"}
                          display={"block"}
                          borderRadius={"11px"}
                          position={"relative"}
                        >
                          {(imagePayment?.path || imagePayment?.imageUrl) && (
                            <Image
                              src={
                                imagePayment?.imageUrl
                                  ? imagePayment?.imageUrl
                                  : `${baseURL}/${imagePayment?.path}`
                              }
                              position={"absolute"}
                              top={0}
                              left={0}
                              right={0}
                              bottom={0}
                              objectFit={"cover"}
                              w={"100%"}
                              h={"100%"}
                              borderRadius={"8px"}
                            />
                          )}
                        </Box>
                        <Flex
                          position={"absolute"}
                          right={"8px"}
                          bottom={"8px"}
                          cursor={"pointer"}
                        >
                          <Box
                            padding={"8px"}
                            bg={"var(--fill-avatar)"}
                            borderRadius={"50%"}
                            mr={"8px"}
                            position={"relative"}
                          >
                            <Input
                              type="file"
                              accept="image/*"
                              multiple
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              width="100%"
                              height="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                changeImage(e, 3, imagePayment?.id)
                              }
                            />
                            <Image
                              src={imageIcon}
                              _hover={{
                                filter: "var(--filter-red)",
                              }}
                            />
                          </Box>
                        </Flex>
                      </Flex>
                    </Box>
                  </Flex>
                </Box> */}

                {/* Ảnh UNC mới */}
                <Box flex={1} mt={"24px"}>
                  <Box mt={6}>
                    <Flex justify="space-between" align="center" mb={2}>
                      <Flex alignItems="center" gap="4px">
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ảnh ủy nhiệm chi
                        </Text>
                        {/* <Text
                          fontSize={{ base: "12px" }}
                          color={"red"}
                          lineHeight={"15px"}
                        >
                          *
                        </Text> */}
                      </Flex>

                      <Button size="sm" onClick={handleAddDelegationImage}>
                        + Thêm ảnh
                      </Button>
                    </Flex>

                    {delegationImage.map((img, index) => (
                      <Box
                        key={img.id || index}
                        mb={4}
                        ref={(el) => (imageRefs.current[index] = el)}
                      >
                        <Flex
                          border="1px solid #ccc"
                          borderRadius="8px"
                          p={2}
                          align="center"
                          gap={4}
                          position={"relative"}
                          justifyContent={"center"}
                        >
                          <Box w="160px" h="200px" position="relative">
                            {img.imageUrl || img.path ? (
                              <Image
                                src={img.imageUrl || `${baseURL}/${img.path}`}
                                objectFit="cover"
                                w="100%"
                                h="100%"
                                borderRadius="8px"
                              />
                            ) : (
                              <Text
                                fontSize="sm"
                                color="gray.400"
                                textAlign="center"
                                mt="80px"
                              >
                                Chưa có ảnh
                              </Text>
                            )}

                            <Input
                              type="file"
                              accept="image/*"
                              opacity={0}
                              position="absolute"
                              top={0}
                              left={0}
                              w="100%"
                              h="100%"
                              cursor="pointer"
                              onChange={(e) =>
                                handleChangeDelegationImage(e, index)
                              }
                            />
                          </Box>

                          <Box
                            position="absolute"
                            top="8px"
                            right="8px"
                            zIndex={2}
                          >
                            <Button
                              size="sm"
                              colorScheme="red"
                              onClick={() => handleRemoveDelegationImage(index)}
                            >
                              Xóa
                            </Button>
                          </Box>
                        </Flex>
                        {!img.imageUrl && !img.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            Vui lòng chọn ảnh
                          </Text>
                        )}
                        {img.imageUrl && !img.status && (
                          <Text
                            fontSize="12px"
                            color="red"
                            lineHeight={"15px"}
                            mt={"8px"}
                            textAlign={"right"}
                          >
                            {img.uploading
                              ? "Đang tải ảnh lên..."
                              : "Tải ảnh lên thất bại, vui lòng bấm Tải lại"}
                          </Text>
                        )}
                        <Flex w={"full"} justifyContent={"flex-end"} mt={2}>
                          {!img.status && img.file && (
                            <Button
                              bg={"var(--linear-gradient-employee)"}
                              color={"var(--color-main)"}
                              fontSize={"12px"}
                              lineHeight={"17px"}
                              // p={"6px 27px 5px 28px"}
                              fontWeight={"600"}
                              _hover={{
                                filter: "brightness(90%)",
                              }}
                              onClick={() => handleUploadDelegationImage(index)}
                              isDisabled={!img.file}
                              h={"28px"}
                              minH={"28px"}
                              w={"90px"}
                              isLoading={isLoadingUpload || img.uploading}
                            >
                              Tải lại
                            </Button>
                          )}
                        </Flex>
                      </Box>
                    ))}

                    {errors?.delegationImage?.message &&
                      !delegationImageError && (
                        <Text fontSize="12px" color="red" lineHeight={"15px"}>
                          {errors?.delegationImage?.message}
                        </Text>
                      )}
                  </Box>
                </Box>
              </Box>
              <Box
                position={"absolute"}
                w={"100%"}
                bottom={"0"}
                bg={"var(--color-main)"}
                borderTop={"0.5px solid var(--bg-line-employee)"}
                borderRadius={"0px 0px 16px 16px"}
                zIndex={3}
              >
                <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                  <Button
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-option-employee-hover)"}
                    borderRadius={"8px"}
                    border={"1px solid var(--color-option-employee-hover)"}
                    bg={"var(--color-main)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                    onClick={onClose}
                  >
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    w={"112px"}
                    p={"13px 20px"}
                    fontSize={"15px"}
                    fontWeight={600}
                    color={"var(--color-main)"}
                    borderRadius={"8px"}
                    bg={"var(--color-option-employee-hover)"}
                    _hover={{
                      filter: "brightness(90%)",
                    }}
                  >
                    Lưu
                  </Button>
                </Flex>
              </Box>
            </Box>
          </form>
        </ModalContent>
      </Modal>
    );
  }
);

export default FormDetail;
